function asList(status, row, vue) {
  if (!!status) {
    const list = vue.$store.state.productCategories.list;
    if (!!list && !!list["results"]) {
      return list.results
        .filter(item => status.includes(item.id))
        .map(item => item.name)
        .join(",");
    }
  }
  return "";
}

export default {
  asList
};
